// src/utils/renderServices.ts
import Services from '../components/sections/Services';

// Cette fonction est utilisée pour rendre les services dans n'importe quel conteneur
export function renderServices(containerId: string): void {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error(`Le conteneur avec l'id ${containerId} n'a pas été trouvé dans le DOM`);
    return;
  }

  // Créer une instance de notre composant Services amélioré
  const servicesComponent = new Services();
  const servicesElement = servicesComponent.getElement();

  // Vider le conteneur et ajouter notre nouvelle implémentation
  container.innerHTML = '';
  container.appendChild(servicesElement);

  console.log('Services rendus avec la nouvelle implémentation');
}
